import { MouseEventHandler, ReactNode } from 'react';

export function GridCell({
  onClick,
  children,
  justifyContent,
  fillRow,
  className,
  id,
  border = 'border-b border-gray-light-10 ',
  capitalize = 'capitalize',
  alignItems = 'center',
}: {
  fillRow?: boolean;
  id?: string;
  children: ReactNode | ReactNode[];
  justifyContent?: 'start' | 'center' | 'end';
  alignItems?: 'start' | 'center' | 'end';
  className?: string;
  onClick?: MouseEventHandler<HTMLDivElement> | undefined;
  border?: string;
  capitalize?: 'capitalize' | 'normal-case';
}) {
  return (
    <div
      style={{
        gridColumn: fillRow ? '1/-1' : undefined,
        justifyContent,
        alignItems,
      }}
      onClick={onClick}
      className={`grid grid-cell w-full p-3 text-gray-dark whitespace-pre-wrap ${className} ${border} ${capitalize}`}
    >
      {children}
    </div>
  );
}
